import { HttpinterceptorService } from './httpinterceptor';
import { UrlProviderService } from './local/url-provider.service';
import { Router } from '@angular/router';
import { AesService } from './local/aes.service';
import * as i0 from "@angular/core";
import * as i1 from "./httpinterceptor";
import * as i2 from "./local/url-provider.service";
import * as i3 from "@angular/router";
import * as i4 from "./local/aes.service";
export class OnlineApplicationService {
    constructor(http, urlProvider, router, aesService) {
        this.http = http;
        this.urlProvider = urlProvider;
        this.router = router;
        this.aesService = aesService;
    }
    submitApplication(requestPayload, isAgentEdit) {
        return this.http.postRequest(this.urlProvider.getSubmitApplicationURL(isAgentEdit), requestPayload).toPromise().then((res) => res);
    }
    getApplication(uuid, identifier, isMainPrewiew = false) {
        return this.http.getRequest(this.urlProvider.getGetApplicationURL(uuid, identifier, isMainPrewiew)).toPromise().then((res) => res);
    }
    checkByIdentifier(identifier) {
        var url = this.urlProvider.checkOnlineApplicationByIdentifier(identifier);
        return this.http.getRequest(url).toPromise().then((res) => res);
    }
    checkMailConfirmationCode(identifier, confirmCode) {
        var url = this.urlProvider.checkOnlineApplicationConfirmationCode(identifier, confirmCode);
        return this.http.getRequest(url, true).toPromise().then((res) => res);
    }
    sendDraft(requestPayload) {
        return this.http.postRequest(this.urlProvider.getSaveDraftURL(), requestPayload).toPromise().then((res) => res);
    }
    purchaseNewProducts(requestPayload, uuid) {
        return this.http.postRequest(this.urlProvider.getPurchaseNewProductsURL(uuid), requestPayload).toPromise().then((res) => res);
    }
    getApplicationByToken(requestPayload) {
        return this.http.postRequest(this.urlProvider.getGetApplicationByTokenURL(), requestPayload).toPromise().then((res) => res);
    }
    approveApplication(requestPayload) {
        return this.http.postRequest(this.urlProvider.approveApplicationURL(), requestPayload).toPromise().then((res) => res);
    }
    rejectApplication(requestPayload) {
        return this.http.postRequest(this.urlProvider.rejectApplicationURL(), requestPayload).toPromise().then((res) => res);
    }
    sendApplicationLinkToAgent(requestPayload) {
        return this.http.postRequest(this.urlProvider.sendApplicationLinkToAgentURL(), requestPayload).toPromise().then((res) => res);
    }
    updateGibRegistrationDate(requestPayload) {
        return this.http.postRequest(this.urlProvider.updateGibRegistrationDateURL(), requestPayload).toPromise().then((res) => res);
    }
    sendApplicationLinkToUnits(identifier) {
        return this.http.getRequest(this.urlProvider.sendApplicationLinkToUnitsURL(identifier)).toPromise().then((res) => res);
    }
    getApplicationHistoryByUUID(uuid) {
        return this.http.getRequest(this.urlProvider.getApplicationHistoryByUUIDURL(uuid)).toPromise().then((res) => res);
    }
    sendMailVerificationForNewForm(email, identifier) {
        var url = this.urlProvider.sendMailVerificationForNewForm(email, identifier);
        return this.http.getRequest(url, true).toPromise().then((res) => res);
    }
    sendMailVerificationForPaymentCancel(email) {
        var url = this.urlProvider.sendMailVerificationForPaymentCancel(email);
        return this.http.getRequest(url, true).toPromise().then((res) => res);
    }
    checkConfirmCodeComparison(confirmCode, encryptedConfirmCode) {
        var url = this.urlProvider.checkConfirmCodeComparison(confirmCode, encryptedConfirmCode);
        return this.http.getRequest(url, true).toPromise().then((res) => res);
    }
    getIdentifierExistCustomer(identifier) {
        var url = this.urlProvider.getIdentifierExistCustomer(identifier);
        return this.http.getRequest(url, true).toPromise().then((res) => res);
    }
    getCancelInformationByIdentifier(identifier) {
        return this.http
            .getRequest(this.urlProvider.getCancelInformationByIdentifier(identifier))
            .toPromise()
            .then((res) => res);
    }
    submitCancelApplication(cancelProduct) {
        return this.http
            .postRequest(this.urlProvider.submitCancelApplication(), cancelProduct)
            .toPromise()
            .then((res) => res);
    }
    updateStatusForNewProducts(identifier, status) {
        return this.http
            .postRequest(this.urlProvider.updateStatusForNewProducts(identifier, status))
            .toPromise()
            .then((res) => res);
    }
    getAliasAndBranchByIdentifier(identifier, appType) {
        return this.http
            .getRequest(this.urlProvider.getAliasAndBranchByIdentifier(identifier, appType))
            .toPromise()
            .then((res) => res);
    }
    cancelOnlineApplication(cancelOnlineApplication) {
        return this.http
            .postRequest(this.urlProvider.cancelOnlineApplication(), cancelOnlineApplication)
            .toPromise()
            .then((res) => res);
    }
    getIsHasContinueCancelApplicationByIdentifier(identifier) {
        return this.http
            .getRequest(this.urlProvider.getIsHasContinueCancelApplicationByIdentifier(identifier))
            .toPromise()
            .then((res) => res);
    }
    // Paynet ödeme servisi
    charge(amount) {
        return this.http
            .postRequest(this.urlProvider.charge(), amount)
            .toPromise()
            .then((res) => res);
    }
    createOnlineApplication(identifier) {
        return this.http
            .postRequest(this.urlProvider.createOnlineApplication(identifier))
            .toPromise()
            .then((res) => res);
    }
    loginWithPortalUser(code) {
        var encodedCode = encodeURIComponent(code);
        return this.http
            .getRequest(this.urlProvider.loginWithPortalUser(encodedCode))
            .toPromise()
            .then((res) => res);
    }
    //guard
    isLoggedIn() {
        const vkntckn = localStorage.getItem("vkntckn");
        if (vkntckn) {
            return true;
        }
        else {
            this.router.navigate(['/form']);
            return false;
        }
    }
    //#region PAYMENT ENDPOINT
    getPaymentPlansByAgent(agentCode) {
        return this.http
            .getRequest(this.urlProvider.getPaymentPlansByAgent(agentCode))
            .toPromise()
            .then((res) => res);
    }
    submitCustomerPaymentPlan(requestPayload, isAgentEdit) {
        return this.http.postRequest(this.urlProvider.getSubmitApplicationURL(isAgentEdit), requestPayload).toPromise().then((res) => res);
    }
    //Payment-Request
    sendPaymentRequest(requestPayload) {
        return this.http.postRequest(this.urlProvider.tdsInitial(), requestPayload).toPromise().then((res) => res);
    }
    sendPaymentChargeRequest(requestPayload) {
        return this.http.postRequest(this.urlProvider.tdsCharge(), requestPayload).toPromise().then((res) => res);
    }
    UpdatePaymentSummary(requestPayload) {
        return this.http.postRequest(this.urlProvider.UpdatePaymentSummary(), requestPayload).toPromise().then((res) => res);
    }
    sendCancelPaymentRequest(requestPayload) {
        return this.http.postRequest(this.urlProvider.reversedRequest(), requestPayload).toPromise().then((res) => res);
    }
    CancelPaymentSummary(requestPayload) {
        return this.http.postRequest(this.urlProvider.CancelPayment(), requestPayload).toPromise().then((res) => res);
    }
    //#endregion
    getCustomerBalanceByIdentifier() {
        let vkn = this.aesService.decrypt(localStorage.getItem("vkntckn"));
        return this.http.getRequest(this.urlProvider.getCustomerBalanceByIdentifierURL(vkn)).toPromise().then((res) => res);
    }
    getCustomerPartnersByIdentifier() {
        let vkn = this.aesService.decrypt(localStorage.getItem("vkntckn"));
        return this.http.getRequest(this.urlProvider.GetCustomerPartnersByIdentifierURL(vkn)).toPromise().then((res) => res);
    }
    sendCustomerNewBalance(request) {
        return this.http.postRequest(this.urlProvider.SendCustomerNewBalance(), request).toPromise().then((res) => res);
    }
    setCustomerMembership(request) {
        return this.http.postRequest(this.urlProvider.SetCustomerMembership(), request).toPromise().then((res) => res);
    }
    getCustomerPartners(identifier) {
        return this.http
            .getRequest(this.urlProvider.getCustomerPartners(identifier))
            .toPromise()
            .then((res) => res);
    }
}
OnlineApplicationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OnlineApplicationService_Factory() { return new OnlineApplicationService(i0.ɵɵinject(i1.HttpinterceptorService), i0.ɵɵinject(i2.UrlProviderService), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i4.AesService)); }, token: OnlineApplicationService, providedIn: "root" });
